import React from 'react';
import { Button } from '../ButtonElement';
import {
    AboutUsContainer,
    AboutUsWrapper,
    BtnWrap,
    ImgWrap,
    Img,
    AboutUsP,
    AboutUsP2,
    AboutUsP3,
    Iframe,
    Image,
    SectionDivider
} from './AboutUsElements';

const AboutUs = ({lightBg, id, imgStart, topLine, lightText, headline, darkText, description, buttonLabel, img, alt, primary, dark, dark2, scrollId, appear, iframeDisplay, imgDisplay, srcLink, Content, Content2, Content3, image2, imgDisplay2, pdf, pdfLink, buttonLabel2}) => {
    return (
        <AboutUsContainer id="about" lightBg={false} topMargin={true} pdf={pdf}>
            <AboutUsWrapper pdf={pdf}>
                
                <AboutUsP>{Content}</AboutUsP>
                
                <ImgWrap imgDisplay={imgDisplay}>
                    <Img src={img} alt={alt}/>
                    <Iframe src={srcLink} width="100%" height="100%" frameBorder="0" marginHeight="0" marginWidth="0" iframeDisplay={iframeDisplay} allowFullScreen></Iframe>
                </ImgWrap>
                
                <SectionDivider />
                
                <AboutUsP2>{Content2}</AboutUsP2>
                
                <ImgWrap imgDisplay={imgDisplay2}>
                    <Image src={image2} alt="Sizing Guidelines Chart"/>
                </ImgWrap>
                
                <SectionDivider />
                
                <AboutUsP3>{Content3}</AboutUsP3>
                
                <BtnWrap>
                    {buttonLabel && <Button to={scrollId} smooth={true} duration={200} spy={true} exact="true" offset={-80} primary={primary ? 1 : 0} dark={dark ? 1 : 0} dark2={dark2 ? 1 : 0} appear={appear}>{buttonLabel}</Button>}
                    {pdf && <Button as="a" href={pdfLink} target="_blank" smooth={true} duration={200} spy={true} exact="true" offset={-80} primary={primary ? 1 : 0} dark={dark ? 1 : 0} dark2={dark2 ? 1 : 0}>{buttonLabel2}</Button>}
                </BtnWrap>
            </AboutUsWrapper>
        </AboutUsContainer>
    )
}

export default AboutUs;
